import { Size, LogGroup, CreateElement, Scale } from "./MyHelpers";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { JackpotText } from "./JackpotText";
import { MoneyFormatter } from "./MoneyFormatter";
import { FontResource } from "./ResourceManager/FontResource";
import { ImageResource } from "./ResourceManager/ImageResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope, ScreenProtocol } from "./ScreenProtocol";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { Settings } from "./Settings";
import { ZIndex } from "./ZIndex";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackPotTextParams } from "./JackPotTextParams";
import { JackpotLevel, JackpotValue2 } from "./api";

export class JackpotDisplayPrecSpin extends  IJackpotDisplay {
	protected view: HTMLElement = null;
	protected viewSize: Size = null;
	protected jpTitle: HTMLElement = null;
	protected titleImage: HTMLElement = null;
	protected commonpath: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	//crea el contenedor como elemento HTMLElement
	//protected jackpotContainer: HTMLElement = null;

	/* protected diamondAnim: CanvasSprite = null;
	protected diamondLocation: Point = new Point(101, 127);
	protected diamondStartTimer: number = -1;

	protected rubyAnim: CanvasSprite = null;
	protected rubyLocation: Point = new Point(407, 333);
	protected rubyStartTimer: number = -1;

	protected shappireAnim: CanvasSprite = null;
	protected shappireLocation: Point = new Point(931, 1052);
	protected shappireStartTimer: number = -1;

	protected emeraldAnim: CanvasSprite = null;
	protected emeraldLocation: Point = new Point(652, 931);
	protected emeraldStartTimer: number = -1;

	 */
	protected platinumFrame: HTMLElement = null;
	protected goldFrame: HTMLElement = null;
	protected silverFrame: HTMLElement = null;
	protected bronzFrame: HTMLElement = null;

	protected titleSpriteAnim: CanvasSprite = null;
	protected titleStartTimer: IRandomInterval = null;

	protected screenProtocol: ScreenProtocol = null;

	protected logGroup: LogGroup = new LogGroup("JackpotDisplayPrecSpin");
	protected systemContext: ISystemContext = null;

	public constructor(params: JackpotDisplayParams) {
		super(params);
		this.systemContext = params.systemContext;
		this.resid = params.resid.Add("JackpotDisplayPreciousSpin");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayPrecSpin");

		console.log("jackpot");
		this.screenProtocol = params.screenProtocol;
		//this.logGroup.SetSpecificName(this.name);

		this.commonpath = Settings.ResourcesFolder + "multigame/slot/common/resources/DiamondSpin";
		this.viewSize = params.viewSize;

		// this would be "view" with jackpot frames
		this.view = document.createElement("div");
		this.view.classList.add(this.resid.ID());
		this.view.style.position = "absolute";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";
		this.view.style.zIndex = ""+ZIndex.JackpotDisplay;


		// recieve message from first screen
		//this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.DiamondAnimation.msgname, (m) => this.DiamondAnimation((<PickBonusMessages.DiamondAnimation>m)), this.screenProtocolScope);
	}


	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		// here is how you "load" the image
		//resourceManager.Add(new ImageResource(this.jackpot + "diamond_pot_title.png", this.resid.ScopedResourceName("diamond_pot_title")));
		resourceManager.Add(new ImageResource(this.commonpath + "/platinumFrame.png", this.resid.ScopedResourceName("platinumFrame")));
		resourceManager.Add(new ImageResource(this.commonpath + "/goldFrame.png", this.resid.ScopedResourceName("goldFrame")));
		resourceManager.Add(new ImageResource(this.commonpath + "/silverFrame.png", this.resid.ScopedResourceName("silverFrame")));
		resourceManager.Add(new ImageResource(this.commonpath + "/bronzeFrame.png", this.resid.ScopedResourceName("bronzeFrame")));


		resourceManager.Add(new FontResource(this.commonpath + "/fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));
		this.TitlePrepare(resourceManager);
		this.AddTextToJackpot();

		await this.jackpotTextMapping[JackpotLevel.Jp4].PrepareResources(resourceManager);
		await this.jackpotTextMapping[JackpotLevel.Jp3].PrepareResources(resourceManager);

		await this.jackpotTextMapping[JackpotLevel.Jp2].PrepareResources(resourceManager);
		await this.jackpotTextMapping[JackpotLevel.Jp1].PrepareResources(resourceManager);
	}

	protected PrepareJpFrames(resourceManager: IReadOnlyResourceManager):void
	{
		
		
		//Diamond Jackpot
		this.platinumFrame = CreateElement("div", {classes:["platinumFrame"], parentToAppend:this.view,
			style:
			{
				position:"absolute",
				right:"0px",
				top:"10px",
				width:"1700px",
				height:"350px",
				backgroundSize:"100% 100%",
				backgroundRepeat:"no-repeat",
			}
		});
		
		
		//Ruby Jackpot
		this.goldFrame = CreateElement("div", {classes:["goldFrame"], parentToAppend:this.view,
			style:
			{
				position:"absolute",
				top:"320px",
				right:"0px",
				width:"1530px",
				height:"315px",
				backgroundSize:"100% 100%",
				backgroundRepeat:"no-repeat",
			}
		});



		//Emerald Jackpot
		this.silverFrame = CreateElement("div", {classes:["silverFrame"],parentToAppend:this.view,
			style:
			{
				position:"absolute",
				top:"603px",
				right:"0px",
				width:"1064px",
				height:"244px",
				backgroundSize:"100% 100%",
				backgroundRepeat:"no-repeat",
			}
		});
		

		//Shappire Jackpot
		this.bronzFrame = CreateElement("div", {classes:["bronzFrame"], parentToAppend:this.view, 
			style:
			{
				position: "absolute",
				top: "852px",
				right: "0px",
				width: "897px",
				height: "234px",
				backgroundSize: "100% 100%",
				backgroundRepeat: "no-repeat",
			}
		})
		
	}

	protected AddTextToJackpot():void
	{
		let jp4TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("JP4"),
			width: Scale.W(1518),
			height: Scale.H(185),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : false,
		}
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = "104px";
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = "104px"; //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";

		let jp3TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("JP3"),
			width: Scale.W(1300),
			height: Scale.H(145),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : false,
		}
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = "138px";
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = "110px";
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";

		let jp2TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(700),
			height: Scale.H(130),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : false,
		}

		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = "250px";
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = "77px";
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";

		let jp1TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(520),
			height: Scale.H(110),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : false,
		}

		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = "223px";
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = "80px";
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		

	}


	public TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new SpriteResource(this.commonpath + "/titlepresious", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public TitleLoaded(resourceManager: IReadOnlyResourceManager) {

		this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(819, 282)});
		this.titleSpriteAnim.View().style.position = "absolute";
		this.titleSpriteAnim.View().style.bottom = "0px";
		this.titleSpriteAnim.View().style.left = "0px";
		this.titleSpriteAnim.View().style.transform = "scale(1.3)";
		this.titleSpriteAnim.View().style.transformOrigin = "bottom left";

		this.view.appendChild(this.titleSpriteAnim.View());
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
		await this.TitleLoaded(resourceManager);

		await this.PrepareJpFrames(resourceManager);
		this.platinumFrame.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("platinumFrame")).CssBackground();
		this.goldFrame.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("goldFrame")).CssBackground();
		this.silverFrame.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("silverFrame")).CssBackground();
		this.bronzFrame.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("bronzeFrame")).CssBackground();


		// repeat at random intervals winthin 5 to 10 seconds
		/* this.diamondAnim.AddOnCompleteCallback(() => this.diamondStartTimer = window.setTimeout(() => this.diamondAnim.Start(false), Math.floor(Math.random() * 5000 + 5000)));
		this.rubyAnim.AddOnCompleteCallback(() => this.rubyStartTimer = window.setTimeout(() => this.rubyAnim.Start(false), Math.floor(Math.random() * 5000 + 5000)));
		this.shappireAnim.AddOnCompleteCallback(() => this.shappireStartTimer = window.setTimeout(() => this.shappireAnim.Start(false), Math.floor(Math.random() * 5000 + 5000)));
		this.emeraldAnim.AddOnCompleteCallback(() => this.emeraldStartTimer = window.setTimeout(() => this.emeraldAnim.Start(false), Math.floor(Math.random() * 5000 + 5000)));
		 */

		this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 10000, 30000, () => this.titleSpriteAnim.Start(false));
		//this.titleSprite.AddOnCompleteCallback(() => this.titleStartTimer = window.setTimeout(() => this.titleSprite.Start(false), Math.floor(Math.random() * 5000 + 5000)));

		this.StartAnimations();

		this.Update();

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();

		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		this.platinumFrame.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
		this.goldFrame.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());
		this.silverFrame.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());
		this.bronzFrame.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());
	}

	public View(): HTMLElement
	{
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void 
	{
		this.titleSpriteAnim.Update();
		this.jackpotTextMapping[JackpotLevel.Jp4].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp1].Draw();
	}

	public StopAnimations(): void {
		// stop animations and their timer to startup in near future

		// if (this.diamondAnim != null) this.diamondAnim.Stop();
		// if (this.diamondStartTimer != -1) { clearTimeout(this.diamondStartTimer); this.diamondStartTimer = -1; }

		// if (this.rubyAnim != null) this.rubyAnim.Stop();
		// if (this.rubyStartTimer != -1) { clearTimeout(this.rubyStartTimer); this.rubyStartTimer = -1; }

		// if (this.shappireAnim != null) this.shappireAnim.Stop();
		// if (this.shappireStartTimer != -1) { clearTimeout(this.shappireStartTimer); this.shappireStartTimer = -1; }

		// if (this.emeraldAnim != null) this.emeraldAnim.Stop();
		// if (this.emeraldStartTimer != -1) { clearTimeout(this.emeraldStartTimer); this.emeraldStartTimer = -1; }

		if (this.titleSpriteAnim != null)
		{
			this.titleSpriteAnim.Stop();
		}
		this.titleStartTimer.Stop();

	}

	public StartAnimations(): void {

		// start within 5 seconds
		// if (this.diamondAnim != null) {
		// 	if (this.diamondStartTimer != -1) clearTimeout(this.diamondStartTimer);
		// 	this.diamondStartTimer = window.setTimeout(() => this.diamondAnim.Start(false), Math.floor(Math.random() * 5000));
		// }

		// if (this.rubyAnim != null) {
		// 	if (this.rubyStartTimer != -1) clearTimeout(this.rubyStartTimer);
		// 	this.rubyStartTimer = window.setTimeout(() => this.rubyAnim.Start(false), Math.floor(Math.random() * 5000));
		// }

		// if (this.shappireAnim != null) {
		// 	if (this.shappireStartTimer != -1) clearTimeout(this.shappireStartTimer);
		// 	this.shappireStartTimer = window.setTimeout(() => this.shappireAnim.Start(false), Math.floor(Math.random() * 5000));
		// }

		// if (this.emeraldAnim != null) {
		// 	if (this.emeraldStartTimer != -1) clearTimeout(this.emeraldStartTimer);
		// 	this.emeraldStartTimer = window.setTimeout(() => this.emeraldAnim.Start(false), Math.floor(Math.random() * 5000));
		// }

		if (this.titleSpriteAnim != null)
		{
			this.titleStartTimer.Start()
		}
	}

	// protected jpValues: JackpotValue2[] = [];
	// public UpdateValues(jackpotValues: JackpotValue2[]): void {
	// 	this.jpValues = jackpotValues;
	// 	if (this.pauseJackpotValues) {
	// 		console.log("IsJackpot");
	// 		return
	// 	}
	// 	let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);
	// 	if (jp1 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp1].SetTarget(jp1.CurrentMultipliedValue);
	// 		//this.bronzValue.innerHTML = this.moneyFormatter.FormatCurrency(jp1.value);
	// 	}

	// 	let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2);
	// 	if (jp2 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp2].SetTarget(jp2.CurrentMultipliedValue);
	// 		//this.silverValue.innerHTML = this.moneyFormatter.FormatCurrency(jp2.value);
	// 	}

	// 	let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
	// 	if (jp3 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp3].SetTarget(jp3.CurrentMultipliedValue);
	// 		//this.rubyvalue.innerHTML = this.moneyFormatter.FormatCurrency(jp3.value);
	// 	}

	// 	let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
	// 	if (jp4 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp4].SetTarget(jp4.CurrentMultipliedValue);
	// 		//this.diamondvalue.innerHTML = this.moneyFormatter.FormatCurrency(jp4.value);
	// 	}
	// }


	public TitleHide() {
		this.titleSpriteAnim.Hide();
		this.titleSpriteAnim.Stop();
	}
	public TitleShow() {
		this.titleSpriteAnim.Show();
		this.titleSpriteAnim.Update();
	}

	// public Reset() {
	// 	console.log("Reset JackpotValues:");
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "ResetValue:", jp.ResetValue);
	// 	});
	// }

	// public Resume() {
	// 	console.log("Resume JackpotValues:");
	// 	this.pauseJackpotValues = false;
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "CurrentValue:", jp.CurrentValue);
	// 	});
	// 	this.UpdateValues(this.jpValues);
	// }

	// protected pauseJackpotValues = false;
	// public Pause() {
	// 	console.log("Pause JackpotValues");
	// 	this.pauseJackpotValues = true;
	// }
}
